import React from 'react';
import InputMask from 'react-input-mask';
import PropTypes from 'prop-types';
import { useField } from 'formik';
import classnames from 'classnames';
import useReadOnly from './useReadOnly';
import useOnUnmount from './useOnUnmount';

const Component = (props) => {
  const [field, meta] = useField(props);
  let { name, readOnly, className, ...other } = props;

  useOnUnmount(props);

  return (
    <InputMask
      {...field}
      value={field.value || ''}
      readOnly={readOnly}
      {...other}
      className={classnames('form-control', className, { 'is-invalid': meta.touched && !!meta.error })}
    />
  );
};
Component.propTypes = {
  name: PropTypes.string.isRequired,
  mask: PropTypes.string.isRequired,
  placeholder: PropTypes.string,
  className: PropTypes.string,
  onUnmount: PropTypes.func,
};

export default Component;
